import '../@claviska/jquery-minicolors/jquery.minicolors'

$(".colorpicker").minicolors();